import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { Meeting } from './meeting';
import { MeetingAttendee } from './meeting-attendee';

@Injectable()
export class MeetingAttendeesService {

  constructor(protected httpClient: HttpClient,
              @Inject('API_BASE_URL') protected baseUrl,
              protected snackbar: MatSnackBar) { }

  getAttendees(meetingId: number): Observable<MeetingAttendee[]> {
    const endpoint = `${this.baseUrl}scheduler/meeting/${meetingId}/attendees`;
    return this.httpClient.get<MeetingAttendee[]>(endpoint);
  }

  checkInAttendee(ids: number[]) {
    const endpoint = `${this.baseUrl}scheduler/meeting/attendees/mark-arrived`;
    return this.httpClient.post(endpoint, { ids });
  }

  getMeetingInformation(meetingId: number): Observable<Meeting> {
    const endpoint = `${this.baseUrl}scheduler/meeting/${meetingId}`;
    return this.httpClient.get<Meeting>(endpoint);
  }

  getMeetingIdByEmail(email: string): Observable<Meeting> {
    const endpoint = `${this.baseUrl}scheduler/meeting-by-email/${email}`;
    return this.httpClient.get<Meeting>(endpoint);
  }

  registerAttendee(attendee: MeetingAttendee) {
    const endpoint = `${this.baseUrl}scheduler/meeting/attendees`;
    return this.httpClient.post(endpoint, attendee);
  }
}
